import { registerWidget } from "@fishaudio/agent-widget";

registerWidget();
